import { useLayoutEffect, useEffect } from 'react';
const useIsomorphicLayoutEffect =
  typeof global.window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
